// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-registration-marks.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-registration-marks/aircraft-registration-marks.js';

mount([g0]);
